import axios from "axios";
import { ORDER_API } from "constants/apiUrls";


// 리뷰 리스트 조회
export async function getReviewList(data) {
  try {
    if(data) {
      const response = await axios.get(`${ORDER_API}/review/ceo`, {
        headers: {Authorization: `Bearer admin`},
        params: data
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}